((InlineCart, $) => {
  'use strict';

  const $dom = {};
  const recProducts = [];
  const doNotAddGeneralPersonalization = window.bvaccel.personalization_exceptions;

  const cacheDom = () => {
    $dom.miniCartOpenButton = $('#CartButton');
    $dom.miniCart = $('[data-inline-cart]');
    $dom.miniCartWrapper = $('.mini_cart');
    $dom.miniCartActionClose = $('[data-inline-cart--action-close]');
  };

  const disableStylehatchAjaxCart = () => {
    // Remove any other submit handles on add to cart form added by StyleHatch
    $('body').off('submit', '#AddToCartForm');
  };

  const updateCartButton = () => {
    $.get('/cart.js', function(data){
      let cartData = data;
      let itemCount = cartData.item_count;
      // Update cart button count & price
      let $cartCount = $('[data-cart-item-count]');
      var $cartCost = $('#CartCost');

      let totalPrice = theme.Currency.formatMoney(cartData.total_price, StyleHatch.currencyFormat);

      $cartCount.text(itemCount);
      $cartCost.removeClass('money');
      $cartCost.html('<span class="money">' + totalPrice + '</span>');

      // If Currency convertor has been added
      if(StyleHatch.currencyConverter){
        Currency.convertAll(StyleHatch.shopCurrency, jQuery('[name=currencies]').val());
      }

    }, 'json');
  };

  const cartAjaxUpdate = (callback) => {
    let $inlineCartForm = $('.mini_cart form[action="/cart"]');
    let inlineCartFormDataSerialized = $inlineCartForm.serializeArray();
    let updatesArray = [];

    $.each(inlineCartFormDataSerialized, function(i, updateItem) {
       updatesArray.push(updateItem.value);
    });

    jQuery.ajax({
        type: 'POST',
        dataType: 'text',
        url: '/cart/update.js',
        data: { updates: updatesArray},
        success: function(data) {
        },
        complete: () => {
          if (typeof callback === 'function') callback();
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error({jqXHR, textStatus, errorThrown });
        }
    });
  };


  /*
    START PRODUCT PERSONALIZATION CART ITEM PROPERTIES
  */
  const verifyCartCustomOptions = () => {
    let lineItemsToRemove = [];

    // GET AND CHECK LATEST CART DATA
    $.get('/cart.js', function(data){
      $.each(data.items, function(i, lineItem) {
        // Only check customized products with properties
        const {
          // _Customizations_Pack_Id = false,
          _Bundle_Id = false,
          _Bundle_Size = false,
        } = lineItem.properties || {};

        // if(_Customizations_Pack_Id) {
        //   var matchFound = data.items.find(item =>
        //       item.key !== lineItem.key
        //       && item.properties['_Customizations_Pack_Id'] === _Customizations_Pack_Id)

        //   if(!matchFound) {
        //     const indexToRemove = i + 1;
        //     lineItemsToRemove.push(indexToRemove); // use line item key for unique ID
        //   }
        // }

        if (_Bundle_Id && _Bundle_Size) {
          const bundleItemsFound = data.items.reduce(
            (count, item) =>
              item.properties["_Bundle_Id"] === _Bundle_Id
                ? count + item.quantity
                : count,
              0
          );

          if (bundleItemsFound !== Number(_Bundle_Size)) {
            lineItemsToRemove.push(i + 1);
          }
        }
      });

      // Set array of products that need to be removed
      $.each(lineItemsToRemove, function(i, lineNumber) {
        let $lineItemUpdateInput = $(`.mini_cart form[action="/cart"] .cart-item[data-line-number="${lineNumber}"]`).find('input[name="updates[]"]');
        // Set update input value to have removed when cart is updated
        // console.log(`Setting Line Number ${lineNumber} to QTY 0`);
        $lineItemUpdateInput.val(0);
      });

      // refresh cart
      cartAjaxUpdate(() => {
        miniCartLoad(false, true);
      });

    }, 'json');
  };

  /*
    GO TO CHECKOUT
  */
  const goToCheckout = () => {
    window.location = '/checkout';
  };
  /*
    Load the mini cart, verify custom options, then go to checkout
  */
  const verifyAndGoToCheckout = () => {
    miniCartLoad(true, false, goToCheckout);
  }

  /*
    MINI CART ACTION - OPEN
  */
  const miniCartOpen = (event) => {
    if (event) {
      event.preventDefault();
    }
    $('.mini_cart').show();
    miniCartAttachCloseEvents();

    FreeGift.bindSelectListener();
  };

  /*
    MINI CART ACTION - Close
  */
  const miniCartClose = (event) => {
    if (event) {
      event.preventDefault();
    }
    $('.mini_cart').hide();
    miniCartDetachCloseEvents();

    FreeGift.removeSelectListener();
  };

  /*
    MINI CART EVENTS - ATTACH EVENT LISTENERS TO CLOSE INLINE-CART
  */
  const miniCartAttachCloseEvents = () => {
    // CLICK - CLOSE WHEN CLICKED OUTSIDE OF INLINE-CART
    $('body').on('click.inline-cart-close', function(event) {
      let closeExceptionsSelectors = ['.mini_cart', '#CartButton'];
      let isException = false;
      $.each(closeExceptionsSelectors, function(index, selector) {
        if ( $(event.target).is(selector) || $(event.target).parents(selector).is(selector) ) {
          isException = true;
        }
      });
      if (!isException) {
        miniCartClose();
      }
    });

    // KEYBOARD - CLOSE ON 'ESC' KEYDOWN
    $('body').on('keydown.inline-cart-close', function(event) {
      // key: "Escape" = keyCode: 27
      if (event.keyCode == 27) {
        $('#CartButton').blur();
        miniCartClose();
      }
    });
  };

  /*
    MINI CART EVENTS - DETACH EVENT LISTENERS TO CLOSE INLINE-CART WHEN NOT NEEDED
  */
  const miniCartDetachCloseEvents = () => {
    $('body').off('click.inline-cart-close keydown.inline-cart-close');
  };

  /*
    MINI CART ACTION - LOAD
  */
  const miniCartLoad = (verifyCart = false, openOnLoad = false, callback) => {
    $.get('/cart?view=mini-cart', function (response) {
      updateCartButton();
      $dom.miniCart.html(response);

      if (verifyCart) {
        verifyCartCustomOptions();
      }

      if(openOnLoad) {
        miniCartOpen();
      }

      if(callback && typeof callback === "function") {
        callback();
      }

      if (window.inlineCartProducts && window.inlineCartProducts.length) {
        window.inlineCartProducts.forEach(p => {
          recProducts[p.id] = {
            settings: {},
            currentVariantOptionValues: []
          }
        });
      }

      $('.cart-recommendation__inner').slick({
        dots: false,
        slidesToScroll: 1,
        slidesToShow: 1,
        infinite: true,
      });


      if (window.nostojs && !verifyCart) {
        const cartRecs = document.querySelector(`.cart-list > .cart-recommendation`);
        if (cartRecs) {
          cartRecs.style.display = `none`;
        }
        window.nostojs(api => {
          api.loadRecommendations();
        });
      }

      initSettings();
      setCurrentOptionValues();
      updateDisabledVariantButtons(true);

      bindRecommendEvents();
      $('body').on('click', '.btn-close--recommendation', function() {
        $('.cart-recommendation').hide();
      });
    });
  };

  const generateRandomNumber = () => {
    return Math.floor(Math.random() * 90000) + 10000;
  };

  // Info for main product
  const getBasicProductFormData = ($form) => {
    let variantId = $form.find('[name="id"]').val();
    let qty = $form.find('[name="quantity"]').val();

    return {
      id: variantId,
      quantity: qty
    };
  }

  /**
   * Gets the name of an ingot from its ID
   *
   * @param {number/String} ingotIDRaw: the product ID of the ingot to add
   *
   * @return {String/boolean}: The name of the ingot if one is found, false otherwise
   */
  const getIngotNameFromID = (ingotIDRaw) => {
    // ensure standard type for ID to check
    const ingotID = parseInt(ingotIDRaw, 10);
    // want to check both colored and collegiate ingot types
    let allIngots = [];
    if (customization.ingot) {
      allIngots = allIngots.concat(customization.ingot.variants);
    }
    if (customization.general) {
      allIngots = allIngots.concat(customization.general.variants);
    }
    if (customization.college) {
      allIngots = allIngots.concat(customization.college.variants);
    }
    // now search all the ingots for a match
    const ingotObject = allIngots ? allIngots.reduce((foundIngot, variant) => {
      return foundIngot ? foundIngot : (variant.id === ingotID ? variant : false);
    }, false) : false;
    return ingotObject ? ingotObject.name : false;
  }

  // Read by the Shopify -> Apparel Magic integration into AM's native emblem fields
  const addApparelMagicEmblem = (properties, initials) => {
    properties._am_emblem = 'uv-numbers-lett';
    properties._am_emblem_attr_2 = 'CSR';
    properties._am_emblem_placement = 'OL';
    properties._am_emblem_finish = 'UV';
    properties._am_emblem_price = '0';
    properties._am_emblem_notes = initials;
  };

  // Larger info for main product (When Personalization Is Active)
  const getPersonalizedProductFormData = (uniqueAddNum, productHandle) => {
    let $productForm = $('.product-template #AddToCartForm');
    let variantId = $productForm.find('[name="id"]').val();
    let qty = $productForm.find('[name="quantity"]').val();
    let ingotID = $productForm.find('[name="properties[Ingot_Color_Variant_Id]"]').val();
    let ingotInitials = $productForm.find('[name="properties[Ingot_Initials]"]').val();
    let ingotTextColor = $productForm.find('[name="properties[_Ingot_Text_Color]"]').val();
    let ingotTextColorReadable = $productForm.find('[name="properties[_Ingot_Text_Color_Readable]"]').val();
    let ingotOrientation = $productForm.find('[name="properties[Initials_Orientation]"]').val();
    let ingotCollege = $productForm.find('[name="properties[Ingot_College]"]').val();
    let ingotMatchProductHandle = $productForm.find('[name="properties[Customizations_For]"]').val();
    let ingotMatchProductKey = uniqueAddNum;
    let type = $productForm.find('.drawer-ingot-active').attr('data-ingot-type');
    let name = getIngotNameFromID(ingotID);
    const addPersonalizationFee = $productForm.find('[data-personalize]').attr("data-add-personalization-fee");

    const data = {
      id: variantId,
      quantity: qty,
      properties: {},
    };

    if (!doNotAddGeneralPersonalization.includes(productHandle)) {
      data.properties._Customizations_Pack_Id = ingotMatchProductKey;
    }

    // Check for empty input of initials between variant click
    let initials = (ingotInitials === '') ? $('.personalize-input').val().toUpperCase() : ingotInitials;
    // Prevent incorrect orientation (occurs when switching variants after initials input)
    ingotOrientation = (initials.length === 3) ? 'Horizontal' : 'Vertical';

    if (addPersonalizationFee === 'true') {
      const productTitle = window.bvaccel.product.title;
      const generalVariant = window.bvaccel.customization.general.variants.filter(function (entry) { return entry.title === productTitle; });
      name = getIngotNameFromID(generalVariant[0].id);
      data.properties.Customization = name;
      data.properties.Type = type;
      data.properties.Initials = initials;
      data.properties.Initials_Orientation = ingotOrientation;
      data.properties._Ingot_Text_Color = ingotTextColor;
      data.properties._Ingot_Text_Color_Readable = ingotTextColorReadable;
      if (ingotTextColorReadable && ingotTextColorReadable !== `Default`) {
        data.properties.Ingot_Text_Color = ingotTextColorReadable;
      }
      addApparelMagicEmblem(data.properties, initials);
    } else if (type == "college") {
      data.properties.Customization = name;
      data.properties.Ingot_Type = type;
      data.properties.Ingot_College = ingotCollege;
      data.properties._Ingot_Text_Color = ingotTextColor;
    } else { // if (type == "initials") 
      data.properties.Customization = name;
      data.properties.Ingot_Type = type;
      data.properties.Ingot_Initials = initials;
      data.properties.Initials_Orientation = ingotOrientation;
      data.properties._Ingot_Text_Color = ingotTextColor;
      data.properties._Ingot_Text_Color_Readable = ingotTextColorReadable;
      if (ingotTextColorReadable && ingotTextColorReadable !== `Default`) {
        data.properties.Ingot_Text_Color = ingotTextColorReadable;
      }
      addApparelMagicEmblem(data.properties, initials);
    }

    return data;
  }

  const isMIY = () => (
    document.querySelector('.miy-step')
  );

  /*
    MINI CART ACTION - REFRESH
  */
  const addPersonalization = (form, previouslyGeneratedNumber = -1) => {
    const $form = $(form);
    const qty = $form.find('[name="quantity"]').val();
    const uniqueAddNum = (previouslyGeneratedNumber >= 0 && previouslyGeneratedNumber) || generateRandomNumber();
    const productHandle = $form.find('[name="handle"]').val(); // fails when product already in cart
    let formData = getBasicProductFormData($form);
    let isPersonalized = $form.find(".personalize-is-active").length > 0;

    if(isPersonalized) {
      formData = getPersonalizedProductFormData(uniqueAddNum, productHandle);
    }

    if (doNotAddGeneralPersonalization.includes(productHandle)) {
      return miniCartLoad(true, true);
    }

    const ingotFreePersonalization = $('[data-personalize]').attr("data-free-ingot");
    const addPersonalizationFee = $('[data-personalize]').attr("data-add-personalization-fee");
    let personalizationVariantId = $('[data-is-personalization-open="true"] .orientation-holder-type.is-active [data-personalize-variant-id]').val();

    const props = {
      Customizations_For: productHandle,
      _Customizations_Pack_Id: uniqueAddNum,
    };

    // use 'general personalization' product for Divot / Flask
    if(addPersonalizationFee === 'true') {
      const productTitle = window.bvaccel.product.title
      const generalVariant = window.bvaccel.customization.general.variants.find(function (entry) { return entry.title === productTitle; }) // looks for Divot, Flask, or Ingot
      personalizationVariantId = generalVariant.id
      props["Initials"] = formData.properties["Initials"];
      props["Initials_Orientation"] = formData.properties["Initials_Orientation"];
    } else if (ingotFreePersonalization === 'true') {
      // use 'general personalization' product for standalone ingot
      const productTitle = window.bvaccel.product.title
      const generalVariant = window.bvaccel.customization.general.variants.find(function (entry) { return entry.title === productTitle; }) // looks for Divot, Flask, or Ingot
      personalizationVariantId = generalVariant.id
      props["Ingot_Type"] = formData.properties["Ingot_Type"];
      props["Ingot_Initials"] = formData.properties["Ingot_Initials"];
      props["Initials_Orientation"] = formData.properties["Initials_Orientation"];
      props["_Ingot_Text_Color"] = formData.properties["_Ingot_Text_Color"];
      props["_Ingot_Text_Color_Readable"] = formData.properties["_Ingot_Text_Color_Readable"];
      props["Ingot_Text_Color"] = formData.properties["Ingot_Text_Color"];
    } else if (formData.properties && formData.properties["Ingot_Type"] && formData.properties["Ingot_Type"] == "initials") {
      // use regular ingot add-on (for bags, etc)
      props["Ingot_Type"] = formData.properties["Ingot_Type"];
      props["Ingot_Initials"] = formData.properties["Ingot_Initials"];
      props["Initials_Orientation"] = formData.properties["Initials_Orientation"];
      props["_Ingot_Text_Color"] = formData.properties["_Ingot_Text_Color"];
      props["Ingot_Text_Color_Readable"] = formData.properties["Ingot_Text_Color_Readable"];
      props["Ingot_Text_Color"] = formData.properties["Ingot_Text_Color"];
    } else if (formData.properties && formData.properties["Ingot_Type"] && formData.properties["Ingot_Type"] == "college") {
      // collegiate ingot
      props["Ingot_College"] = formData.properties["Ingot_College"];
    }

    if(ingotFreePersonalization === 'true') {
      props["_free_ingot_personalization"] = true;
    }

    const item = {
      quantity: qty,
      id: personalizationVariantId,
      properties: props,
    };

    return item;
  };

  const miniCartAddProduct = (form) => {
    const $form = $(form);

    // Main Product Info
    const uniqueAddNum = generateRandomNumber();
    const productHandle = $form.find('[name="handle"]').val();
    const itemsToAdd = [];
    let formData = getBasicProductFormData($form);
    let isPersonalized = $form.find(".personalize-is-active").length > 0;

    if(isPersonalized) {
      formData = getPersonalizedProductFormData(uniqueAddNum, productHandle);
      if (!isMIY()) {
        itemsToAdd.push(addPersonalization(form, uniqueAddNum));
      }
    }

    itemsToAdd.unshift(formData); // add item to the front of the array

    $.ajax({
      type: 'POST',
      data: { items: itemsToAdd },
      url: '/cart/add.js',
      dataType: 'json',
      success: (data, textStatus, jqXHR) => {
        miniCartLoad(true, true);
      }
    });
  };

  /*
    MINI CART ACTION - REMOVE LINE-ITEM
  */
  const miniCartRemoveLineItem = (id, callback) => {
    jQuery.ajax({
        type: 'POST',
        dataType: 'text',
        url: '/cart/update.js',
        data: `updates[${id}]=0`,
        success: function() {
          if(typeof callback === 'function'){
            return callback();
          }
        }
    });
  };

  const miniCartRemoveBundle = (bundleId, callback) => {
    const bundleItems = [...document.querySelectorAll(`[data-cart-remove-line-item][data-bundle="${bundleId}"]`)];
    const lineUpdates = bundleItems.reduce((updates, removeBtn) => {
      updates[removeBtn.dataset.itemKey] = 0;
      return updates;
    }, {});

    jQuery.ajax({
      type: 'POST',
      dataType: 'text',
      url: '/cart/update.js',
      data: { updates: lineUpdates },
      success: function() {
        if(typeof callback === 'function') {
          return callback();
        }
      }
    });
  };

  /*
    MINI CART ACTION - UPDATE LINE-ITEM QUANTITY
  */
  const miniCartUpdateLineItemQuantity = (id, quantityValue, callback) => {
    jQuery.ajax({
        type: 'POST',
        dataType: 'text',
        url: '/cart/update.js',
        data: `updates[${id}]=${quantityValue}`,
        success: function() {
          if(typeof callback === 'function') {
            return callback();
          }
        }
    });
  };

  /*
    MINI CART ACTION - OPEN NOTE ACCORDION
  */
  const toggleNote = () => {
    if ($('.sidecart-note__text').hasClass('open')) {
      $('.sidecart-note__text').removeClass('open');
      $('.sidecart-note__save').removeClass('saved')
      $('.sidecart-note__open').html('+');
    }
    else {
      $('.sidecart-note__text').addClass('open');
      $dom.miniCartWrapper.animate({ scrollTop: $('.sidecart-note__text').position().top }, 300);
      $('.sidecart-note__open').html('-');
    }
  };

  /*
    MINI CART ACTION - UPDATE ORDER NOTE
  */
  const updateNote = (note, callback) => {
    jQuery.ajax({
        type: 'POST',
        dataType: 'text',
        url: '/cart/update.js',
        data: `note=${note}`,
        success: function() {
          $('.sidecart-note__save').addClass('saved')
        }
    });
  };

  const bindUIActions = () => {
    // HOLIDAY BUNDLE SCRIPT
    const incSubmit = () => {
      // have to submit with interval so it updates cart
      $('.js-holiday-bundle-form-1').submit();
      setTimeout(() => {
        $('.js-holiday-bundle-form-2').submit();
      }, 1500);
    };

    // INLINE CART SHOW
    $dom.miniCartOpenButton.on('click' ,function(event) {
     miniCartOpen(event);
     $(window).trigger('resize');
    });

    // INLINE CART HIDE
    $('body').on('click', '[data-close-cart]', function(event) {
      miniCartClose(event);
    });

    // PRODUCT DISPLAY PAGE ADD TO CART
    $('body').on('submit', '#AddToCartForm', function(event) {
      event.preventDefault();

      // prevent premature submissions
      const atcButton = $(event.target).find('button[type="submit"]');
      if(atcButton.length > 0 && atcButton.hasClass('not-allowed')) return;
      miniCartAddProduct(event.target);
    });

    // REMOVE LINE-ITEM
    $('body').on('click', '[data-cart-remove-line-item]', function(event) {
      event.preventDefault();
      const lineItemKey = this.dataset.itemKey;
      const bundleKey = this.dataset.bundle;
      let callback = () => {
        if (window.location.href.indexOf("/cart") > -1) {
          window.location.reload();
        }
        else {
          miniCartLoad(false, false);
        }
      };
      if (bundleKey && bundleKey !== '') {
        miniCartRemoveBundle(bundleKey, callback);
      } else if(this.dataset.freeGiftRemove !== undefined) {
        callback = () => {
          if (window.location.href.indexOf("/cart") > -1) {
            window.location.reload();
          }
          else {
            miniCartLoad(false, true);
          }
        };
        miniCartRemoveLineItem(lineItemKey, callback);
      } else {
        callback = () => {
          if (window.location.href.indexOf("/cart") > -1) {
            window.location.reload();
          }
          else {
            miniCartLoad(true, true);
          }
        };
        miniCartRemoveLineItem(lineItemKey, callback);
      }
    });

    // UPDATE LINE-ITEM QUANTITY
    $('body').on('change blur', '[data-cart-update-line-item-quantity]', function(event) {
      event.preventDefault();
      let lineItemKey = $(this).attr('data-item-key');
      let lineItemQuantity = $(this).val();

      if ( $(this).is('[data-cart-line-item-with-properties]') == true ) {
        $(this).parents('form').find('input[name="update"]').trigger('click');
      } else {
        const callback = () => { 
          miniCartLoad(false, true);
        }
        miniCartUpdateLineItemQuantity(lineItemKey, lineItemQuantity, callback);
      }
    });

    // INLINE CART SHIPPING MESSAGE "CONTINUE SHOPPING" CLOSE BUTTON
    $('body').on('click', '[data-inline-cart--action-close]', function(event) {
      event.preventDefault();
      miniCartClose();
    });

    // INLINE CART CHECKOUT BUTTON
    $('body').on('click', '[data-goto-checkout]', function(event) {
      event.preventDefault();
      verifyAndGoToCheckout();
    });

    // ORDER NOTE
    $('body').on('click', '[data-note-toggle]', toggleNote);

    $('body').on('click', '[data-note-submit]', function() {
      updateNote($('.sidecart-note__textarea').val());
    });

    $('.mini_cart').on('click', '.cart-recommendation .product--atc-button', () => {
      $('.mini_cart').scrollTop(0);
    });
  };

  const bindRecommendEvents = () => {
    $('.cart-recommendation .single-product .js-product-variant-display-value').on("click", function () {
      changeVariantOption($(this));
    });

    $('.cart-recommendation .single-product  [data-name="Color"] .js-product-variant-display-value').on('mouseenter', function() {
      $(this)
      .closest(".product--variant-display-option")
      .find(".js-product-current-variant-option")
      .text($(this).data("value"));
    })

    $('.cart-recommendation .single-product [data-name="Color"] .js-product-variant-display-value').on('mouseout', function() {
      const productId = $(this).closest('.single-product').data('product-id');
      const optionNum = $(this)
      .closest(".product--variant-display-list")
      .data("option");
      $(this)
        .closest(".product--variant-display-option")
        .find(".js-product-current-variant-option")
        .text(recProducts[productId].settings[optionNum].value);
    })

    $(".cart-recommendation .single-product .js-product-variant-option-selector").on('change', function() {
      const productId = $(this).closest('.single-product').data('product-id');
      const optionName = $(this).data("name");
      const optionNum = $(this).data("option");
      const optionIndex = Number(optionNum.replace("option","")) - 1;
      const value = $(this).val();
      recProducts[productId].settings[optionNum].value = value;
      $(this).closest('.single-product').find(`.js-product-current-variant-option[data-name=${optionName}]`).attr(
        'data-value',
        value.charAt(0).toUpperCase() + value.slice(1)
      );

      setCurrentOptionValues();
      updateDisabledVariantButtons();
      const trimmedValue = recProducts[productId].currentVariantOptionValues[optionIndex].replace("Inseam", "");
      $(this).closest('.single-product').find(`.js-product-current-variant-option[data-name=${optionName}]`).text(trimmedValue);
    })

    $('.cart-recommendation .single-product .js-product-variant-display-value').on('mouseenter', function(event) {
      setCurrentOptionValues();
    })
  }

  // disable product variant selectors based on selected variant
  const updateDisabledVariantButtons = (first = false) => {
    const index = $('.cart-recommendation .slick-slide.slick-active .single-product').data('recommend-index');
    const product = window.inlineCartProducts && window.inlineCartProducts.length ? window.inlineCartProducts[index] : null;
    const variantGroups = Array.from(
      document.querySelectorAll(".cart-recommendation .slick-slide.slick-active .single-product .js-variant-option-control")
    );

    if (product) {
      product.options.forEach((option, index) => {
        // options besides the current one
        const otherOptions = Object.keys(product.options).filter(option => option !== String(index));
        // get an array of in-stock variants that matches the currentVariant
        // on at least one of the matching 'other' options
        const filteredInStockVariants = product.variants.filter(productVariant => {
          if (!productVariant.available) return false;
          for (let i = 0; i < otherOptions.length; i++) {
            if (recProducts[product.id].currentVariantOptionValues[otherOptions[i]] != productVariant.options[otherOptions[i]]) {
              return false;
            }
          }
          return true;
        })
          .map(productVariant => {
            return productVariant.options[index];
          });

        // update this option's corresponding button selectors
        const thisOptionGroup = variantGroups.find(group => group.getAttribute('data-option') === `option${index + 1}`);
        const theseOptions = Array.from(thisOptionGroup.querySelectorAll(`.js-product-variant-display-value`));
        theseOptions.forEach(button => {
          button.classList.remove('is-disabled');
          const buttonValue = button.getAttribute('data-value');
          if (filteredInStockVariants.indexOf(buttonValue) === -1) {
            button.classList.add('is-disabled');
          }
        });
      });
    }
  }

  const setCurrentOptionValues = () => {

    $('.cart-recommendation .single-product').each(function() {
      const productId = $(this).data('product-id');

      const productOptionCurrentValues = Array.from(
        document.querySelectorAll(`.cart-recommendation .single-product[data-product-id="${productId}"] .product--variant-display-option .js-product-current-variant-option`)
      )
      .map(span => {
        // remove 'Inseam' and re-add only one (avoids a bug on undefined variants)
        let value = span.getAttribute('data-value').replace('Inseam ', '');
        if(span.getAttribute('data-name') === 'Inseam') {
          value = 'Inseam ' + value;
        }
        return value;
      });

      recProducts[productId].currentVariantOptionValues = productOptionCurrentValues;
    });
  }

  const changeVariantOption = ($that) => {
    if (!$that.hasClass("is-active")) {
      // select the nearest list of custom variant selectors
      const $displayList = $that.closest(".product--variant-display-list");
      // get the option data from this list
      const optionName = $displayList.data("name");

      let currentValue = $that.data("value").toString().toLowerCase();
      // update the single option selector using the data attribute on custom selector
      const $selectList = $that.closest('.single-product').find(`.js-product-variant-option-selector[data-name='${optionName}']`);
      $selectList.find("option").each(function () {
        if ($(this).val().toString().toLowerCase() === currentValue) {
          $selectList.val($(this).val()).change();
          return false;
        }
      });

      // add the active class to the clicked selector
      $displayList.find(".is-active").removeClass("is-active");
      $that.addClass("is-active");
      const recIndex = $that.closest('.single-product').data('recommend-index');

      //change product variant selector
      const activeOptions = $that.closest('.single-product').find('.js-product-variant-display-value.is-active');
      let activeOptionValues = [];
      activeOptions.each(function() {
        activeOptionValues.push($(this).data('value'));
      });

      window.inlineCartProducts[recIndex].variants.forEach(v => {
        if(activeOptionValues.length == 1 && v.option1 == activeOptionValues[0] || activeOptionValues.length > 1 && v.option1 == activeOptionValues[0] && v.option2 == activeOptionValues[1]) {
          $that.closest('.single-product').find(`.js-product-variant-selector`).val(v.id);
        }
      })
    }
  };

  const initSettings = () => {
    $('.cart-recommendation .single-product').each(function(){
      const productId = $(this).data('product-id');

      $(this).find(".js-product-variant-option-selector").each(function () {
        const optionName = $(this).data("name");
        const optionNum = $(this).data("option");
        const value = $(this).val();
        recProducts[productId].settings[optionNum] = {
          name: optionName,
          value: value,
        };
      });
    });
  };

  /**
   * removeMIYItems - remove the existing MIY items from cart
   * @returns {Promise|Array}
   */
  const removeMIYItems = async () => {
    const miyFirstItem = document.querySelector('.miy-line-item .cart-item--remove');
    if (miyFirstItem) {
      miyFirstItem.click();
    }
    return miyFirstItem;
  };

  const init = () => {
    disableStylehatchAjaxCart();
    cacheDom();
    miniCartLoad();
    bindUIActions();
  };

  // ----- MINI CART METHODS ---------------------------------------------------
  InlineCart.init = init;
  InlineCart.miniCartOpen = miniCartOpen;
  InlineCart.miniCartClose = miniCartClose;
  InlineCart.miniCartLoad = miniCartLoad;
  InlineCart.miniCartAddProduct = miniCartAddProduct;
  InlineCart.removeMIYItems = removeMIYItems;
  InlineCart.addPersonalization = addPersonalization;
  InlineCart.addApparelMagicEmblem = addApparelMagicEmblem;
})(window.InlineCart = window.InlineCart || {}, jQuery);
